import { render, staticRenderFns } from "./edit_category.vue?vue&type=template&id=103ab4f6&"
import script from "./edit_category.vue?vue&type=script&lang=js&"
export * from "./edit_category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports